(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'qualSummaryCardWide', {
            bindings: {
                content: '<',
                /** `vm.metadata` can be required by some of the included components (fees, key dates) - make an alias of this rather than renaming it if necessary */
                metadata:      '<' // Expects immutable object
            },
            templateUrl:  'app/views/partials/widgets/qual-summary-card-wide.html',
            controller:   QualSummaryCardWideController,
            controllerAs: 'vm'
        });


    /**
     * Wide card summarising main attributes of any postgraduate or
     * undergraduate programme.
     *
     * Important: In case any significant changes are made to this component,
     * please re-test according to the https://victoriauniversity.atlassian.net/wiki/spaces/WT/pages/168198145/Blackbox+testing+guide+for+Topics+Programmes#BlackboxtestingguideforTopics&Programmes-Qualification'relatedoptions'cards
     *
     * @param {ng.IScope} $scope
     * @param {LoggerFactory} LoggerFactory
     * @param {ContentSwitchingService} ContentSwitchingService
     * @param {SubpagesService} SubpagesService
     * @param {Object} TEXTS
     * @param {Object} CONFIG
     */
    function QualSummaryCardWideController(
        $scope,
        LoggerFactory,
        ContentSwitchingService,
        SubpagesService,
        TEXTS,
        CONFIG
    ){

        /** @type {angular.IController} */
        var vm     = this;






        /* ===== PRIVATE MEMBERS ============================================ */


        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'QualSummaryCardWide', false );





        /* ===== EXPOSE TO THE SCOPE ======================================== */


        $scope._ = TEXTS.GENERIC.SUMMARY_CARD_WIDE;
        $scope.SUBQUAL_TYPE_PROFESSIONAL_POSTGRAD = 'programme';





        /* ===== EXPOSE TO THE CONTROLLER =================================== */


        vm.setKeyDatesCount = function ( datesModel ) {
            vm.keyDatesCount = datesModel ? datesModel.length : null;
        };





        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        vm.$onInit = function() {
            setWatchers();
        }





        /* ===== PRIVATE FUNCTIONS ========================================== */


        /** Uni-directional watchers */
        vm.$onChanges = function( changesObject ) {
            if ( changesObject.metadata && changesObject.metadata.currentValue ) {
                initModel();
                vm.$onChanges = function(){}; // Deregister event handler after qual's metadata are loaded
            }
        };


        function setWatchers() {
            $scope.$watch( 'ContentSwitchingService.contentType', function() {
                vm.isInternationalContent = ContentSwitchingService.isInternational();

                if ( vm.hasOwnProperty( 'metadata' ) && vm.metadata ){
                    vm.qual = vm.isInternationalContent && vm.metadata.hasOwnProperty( 'international' ) ? vm.metadata[ 'international' ] : vm.metadata;
                }
            });
        }


        function initModel() {
            if ( vm.metadata ) {
                vm.targetStateParams = getQualsTargetStateParams();
                ContentSwitchingService.initInternationalOnObject( vm.metadata );
            } else {
                logger.error( "Qualification is missing a `metadata` attribute - Cannot render its summary card!" );
            }
        }


        /**
         * Constructs parameters required by `ui-sref` template
         * directive that might be used to dynamically construct URL to the
         * given qualification.
         *
         * @returns {{ id: string, queries: Object }}
         */
        function getQualsTargetStateParams() {
            var stateId = '.', stateQueries = {},
            qual = vm.metadata;

            if ( !qual ){
                return null;
            }

            if ( !( qual.hasOwnProperty( 'parent' ) && qual.parent.hasOwnProperty( 'type' ) && qual.parent.hasOwnProperty( 'id' ) )){
                logger.error( "Missing attribute `parent` or any of its sub attributes `type` or `id` inside the metadata or related qualification (#%s). Cannot construct the button with URL referencing degree/programme page.", qual.id, qual );

                return null;
            }

            // Resolve 'type' into specific state ID and set query
            switch( qual.parent.type ) {

                case CONFIG.ROUTES.DEGREES: {
                    stateId = CONFIG.STATES.DEGREE;

                    stateQueries[ CONFIG.PARAMS.DEGREE_ID ] = qual.parent.id;
                } break;

                case CONFIG.ROUTES.GRADUATE_QUALS: {
                    stateId = CONFIG.STATES.POSTGRAD;

                    stateQueries[ CONFIG.PARAMS.POSTGRAD_ID ] = qual.parent.id;
                    stateQueries[ CONFIG.PARAMS.QUAL_TYPE ]   = CONFIG.ROUTES.GRADUATE_QUALS;
                } break;

                case CONFIG.ROUTES.OTHER_QUALS: {
                    stateId = CONFIG.STATES.POSTGRAD;

                    stateQueries[ CONFIG.PARAMS.POSTGRAD_ID ] = qual.parent.id;
                    stateQueries[ CONFIG.PARAMS.QUAL_TYPE ]   = CONFIG.ROUTES.OTHER_QUALS;
                } break;

                case CONFIG.ROUTES.POSTGRADS: {
                    stateId = CONFIG.STATES.POSTGRAD;

                    stateQueries[ CONFIG.PARAMS.POSTGRAD_ID ] = qual.parent.id;
                    stateQueries[ CONFIG.PARAMS.QUAL_TYPE ]   = CONFIG.ROUTES.POSTGRADS;
                } break;

                default: {
                    logger.error( "Unknown `parent.type` `%s` inside the metadata of related qualification `%s` (#%s). Cannot construct the button with URL referencing degree/programme page.", qual.parent.type, qual.parent.name, qual.id, qual );
                }
            }


            // Define a query for pre-selecting sub-qualification (major/subject/programme)
            if ( qual.hasOwnProperty( 'type' ) && isSubqualQuerySupported( qual.type ) ){
                if ( qual.hasOwnProperty( 'orphan' ) && qual.orphan ) {
                    // It's a single qual under its parent = don't construct anything!
                    logger.debug( "Sub-qualification `%s` is the only one in its parental qualification - do not render URL with pre-selected `%s` query.", qual.name, qual.type, qual );
                } else if ( qual.hasOwnProperty( 'id' ) && qual.id ) {
                    stateQueries[ qual.type ] = qual.id;
                } else {
                    logger.warn( "Missing attribute `id` (or containing unknown value `%s`) inside the metadata of related qualification `%s`. Cannot construct a button that will pre-select given sub-qualification.", qual.id, qual.parent.name );
                }
            } else if ( qual.hasOwnProperty( 'type' ) && qual.type !== null ) {
                logger.warn( "Missing attribute `type` (or containing unknown value `%s`) inside the metadata of related qualification `%s`. Cannot construct a button that will pre-select given sub-qualification.", qual.type, qual.parent.name );
            }

            ContentSwitchingService.addGenericParamsToStateQuery( stateQueries );

            return {
                id:         stateId,
                queries:    stateQueries
            }
        }


        function isSubqualQuerySupported( queryName ) {
            return [ CONFIG.PARAMS.PROGRAMME, CONFIG.PARAMS.SUBJECT, CONFIG.PARAMS.PRIMARY_MAJOR ].indexOf( queryName ) > -1;
        }
    }



    QualSummaryCardWideController.$inject   = [ '$scope', 'LoggerFactory', 'ContentSwitchingService', 'SubpagesService', 'TEXTS', 'CONFIG' ];
})();
